import TableReferenceIdAndKeyDto from "./../TableReferenceIdAndKeyDto";

export default class TableSelectionDto {

    constructor(table: TableReferenceIdAndKeyDto | null) {
        this.Table = table;
    }

    Table: TableReferenceIdAndKeyDto | null;
}